import { render } from "./Accordion.vue?vue&type=template&id=1e8c8ce4"
import script from "./Accordion.vue?vue&type=script&setup=true&lang=js"
export * from "./Accordion.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/Paragraphs/Accordion.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1e8c8ce4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1e8c8ce4', __exports__)) {
    api.reload('1e8c8ce4', __exports__)
  }
  
  module.hot.accept("./Accordion.vue?vue&type=template&id=1e8c8ce4", () => {
    api.rerender('1e8c8ce4', render)
  })

}


export default __exports__